<template>
	<tbody>
		<tr>
			<td valign="top">
				<v-card flat color="transparent">
					<v-layout class="ma-0">
						<v-flex xs5 class="pa-0">
							<v-img
								:src="
									getObjectValue('part.photo_url', line_item)
								"
								aspect-ratio="1.25"
								class="elevation-5"
								contain
								:style="
									category &&
									category.slug === 'nutting-carts-trailers'
										? 'background-color: #FFFFFF;'
										: 'background-color: #00529c;'
								"
							></v-img>
						</v-flex>
						<v-flex xs7 class="pa-0">
							<v-card-text>
								<h4
									class="title mb-1 grey--text"
									v-if="category"
								>
									{{ category.name }}
								</h4>
								<h4 class="title mb-2 grey--text">
									#{{ product.display_sku }}
								</h4>
								<h3 class="headline font-weight-bold mb-0">
									{{ product.name }}
								</h3>
								<h4>{{ product.price | currency }}</h4>
							</v-card-text>
						</v-flex>
					</v-layout>
				</v-card>
			</td>

			<td valign="top">
				<div
					v-if="line_items_editable"
					class="proposal-table__actions text-xs-right"
				>
					<v-tooltip top>
						<template v-slot:activator="{ on }">
							<v-btn
								icon
								class="ma-0"
								@click="removeLineItem"
								v-on="on"
							>
								<fa-icon
									:icon="['far', 'trash-alt']"
									class="error--text"
									size="lg"
								/>
							</v-btn>
						</template>
						<span>Remove</span>
					</v-tooltip>

					<v-tooltip top>
						<template v-slot:activator="{ on }">
							<v-btn
								icon
								class="ma-0"
								@click="editLineItem"
								v-on="on"
							>
								<fa-icon
									icon="pencil-alt"
									class="success--text"
									size="lg"
								/>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
				</div>

				<div
					v-if="modifiedOptions.length > 0 || line_item.weight"
					class="selected-options mt-2"
				>
					<ul
						class="selected-options__list selected-options__list--tabled"
					>
						<li v-for="mod in modifiedOptions" :key="mod.slug">
							<span class="selected-options__text">
								<div class="selected-options__label">
									<span
										:class="{ colon: mod.type !== 'bool' }"
										>{{ mod.name }}</span
									>
									<span v-if="mod.type !== 'bool'">
										{{ mod.value }}
										<span
											v-if="
												mod.units && mod.type === 'int' && mod.value > 0
											"
											v-text="
												parseFloat(mod.value) > 1
													? mod.units
													: mod.units_singular
											"
											style="text-transform: capitalize;"
										></span>
									</span>
								</div>
								<div
									class="selected-options__price"
									v-if="mod.price"
								>
									{{ mod.price | currency }}
								</div>
							</span>
						</li>

						<!-- Weight -->
						<li v-if="line_item.weight">
							<span class="selected-options__text">
								<div class="selected-options__label">
									<span class="colon">Weight</span>
									<span>
										{{ line_item.weight }}
										<span>lbs</span>
									</span>
								</div>
							</span>
						</li>
					</ul>
				</div>
			</td>
		</tr>
		<tr>
			<td colspan="2">
				<div class="v-table__overflow pricing-table">
					<table class="v-table theme--light">
						<thead>
							<tr>
								<th
									v-if="document.show_line_item_prices"
									class="text-xs-left"
								>
									Suggested List Price
								</th>
								<th
									v-if="
										!document.for_customer &&
											document.show_net_price
									"
									class="text-xs-left"
								>
									Dealer Net Price
								</th>
								<th
									v-if="
										document.for_customer &&
											document.show_customer_price
									"
									class="text-xs-left"
								>
									Set End User Price
								</th>
								<th class="text-xs-center" width="30">Qty</th>
								<th class="text-xs-right">Total</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td
									v-if="document.show_line_item_prices"
									class="text-xs-left"
								>
									<span class="subheading font-weight-bold">
										{{ listPrice | currency }}
									</span>
								</td>
								<td
									v-if="
										!document.for_customer &&
											document.show_net_price
									"
									class="text-xs-left"
								>
									<span class="subheading font-weight-bold">
										{{ netPrice | currency }}
									</span>
								</td>
								<td
									v-if="
										document.for_customer &&
											document.show_customer_price
									"
									class="text-xs-left"
								>
									<currency-input
										v-if="line_items_editable"
										v-model="quote_price"
										@blur="updateLineItem"
										class="subheading"
									></currency-input>
									<span
										v-else
										class="subheading font-weight-bold"
										>{{ quote_price | currency }}</span
									>
								</td>
								<td class="text-xs-center">{{ quantity }}</td>
								<td class="text-xs-right">
									<span class="title font-weight-bold">
										{{ lineItemPrice | currency }}
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</td>
		</tr>
	</tbody>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CurrencyInput from "@components/partials/CurrencyInput";
import TransitionExpand from "@components/partials/TransitionExpand";

var { quoteBuilder } = require("@root/mixins");

export default {
	mixins: [quoteBuilder],

	data() {
		return {
			name: "",
			quantity: 0,
			quote_price: 0,
			include_drawings: false
		};
	},

	props: {
		line_items_editable: {
			default: false
		},

		line_item: {
			default: null
		}
	},

	components: { CurrencyInput, TransitionExpand },

	computed: {
		...mapGetters("products", ["categories"]),

		type() {
			return this.getObjectValue("line_item.part_id", this, null) === null
				? "option"
				: "part";
		},

		product() {
			return this.line_item.part;
		},

		category() {
			return _.find(this.categories, ["id", this.product.part_family_id]);
		},

		configuration() {
			return this.line_item.configuration;
		},

		modifiedOptions() {
			const { part, modified } = this.line_item;

			const options = [
				...part.attributes.filter(attribute => {
					return (
						!attribute.hidden &&
						attribute.field_configuration === null
					);
				}),
				...modified
			];

			return options;
		},

		listPrice() {
			return (
				this.line_item.list_price + this.line_item.configuration_price
			);
		},

		netPrice() {
			return (
				this.line_item.modified_price +
				this.line_item.modified_configuration_price
			);
		},

		lineItemPrice() {
			let price = this.listPrice;

			if (!this.document.for_customer && this.document.show_net_price) {
				price = this.netPrice;
			}

			if (
				this.document.for_customer &&
				this.document.show_customer_price
			) {
				price = this.quote_price;
			}

			return this.quantity * price;
		}
	},

	methods: {
		...mapActions("quote-builder", {
			UPDATE_PART: "updatePart",
			UPDATE_OPTION: "updateOption",
			REMOVE_LINE_ITEM: "removeLineItem",
			UPDATE_INCLUDE_DRAWINGS: "updateIncludeDrawings"
		}),

		removeLineItem() {
			let document = this.CURRENT_DOCUMENT_BY_ID(
				this.line_item.document_id
			);

			this.line_item.type = this.type;

			this.REMOVE_LINE_ITEM({
				document_number: document.number,
				line_item: this.line_item
			});
		},

		editLineItem() {
			let document = this.CURRENT_DOCUMENT_BY_ID(
				this.line_item.document_id
			);

			const path = `/configurator/${document.number}/customize/${
				this.line_item.id
			}`;

			this.$router.push({ path });
		},

		updateLineItem() {
			let document = this.CURRENT_DOCUMENT_BY_ID(
				this.line_item.document_id
			);

			this[`UPDATE_${this.type.toUpperCase()}`]
				.call(this, {
					document_number: document.number,
					line_item: this.line_item,
					quantity: this.type === "part" ? this.quantity : 1,
					name: this.type === "option" ? this.name : null,
					price: this.quote_price
				})
				.then(() => {
					this.editing = false;
				});
		},

		updateIncludeDrawings: _.debounce(function() {
			if (this.type === "option") {
				return;
			}

			this.UPDATE_INCLUDE_DRAWINGS({
				document_id: this.line_item.document_id,
				line_item: this.line_item,
				include_drawings: this.include_drawings
			});
		}, 200),

		cancelUpdate() {
			this.quote_price = this.line_item.quote_price;
			this.quantity = this.line_item.quantity;

			this.editing = false;
		}
	},

	mounted() {
		const quote_price = parseFloat(this.line_item.quote_price).toFixed(2);

		if (!isNaN(quote_price)) {
			this.quote_price = quote_price;
		}

		this.quantity = this.line_item.quantity;
		this.name = this.line_item.name;
		this.include_drawings = this.line_item.include_drawings;

		this.$watch("include_drawings", value => {
			this.updateIncludeDrawings();
		});
	}
};
</script>
